<template>
    <div class="container issue-form">

        <div class="row">
            <h1>
                <i class="fas fa-clipboard-list"></i>
                New Issue
            </h1>
        </div>

        <div class="row">
            <h2>Message</h2>
            <input
                    type="text"
                    name="message"
                    id="issue-message"
                    v-model="message"
                    :disabled="loading"
            />
        </div>

        <div class="row">
            <h2 class="issue-field-required">Reason</h2>
            <v-select
                    :options="reasons"
                    :reduce="reason => reason.id"
                    label="reason"
                    v-model="reason_id"
                    placeholder="Reason"
                    :disabled="loading"
                    :searchable="false"
                    :clearable="false"
                    id="reason_id"
            ></v-select>
        </div>

        <div class="row issue-buttons">
            <button class="btn btn-issue-close" @click="closeModal">
                <i class="fas fa-times"></i>
                Cancel
            </button>
            <button class="btn btn-issue-create" @click="submitIssue" :disabled="loading || reason_id === null">
                <i class="fas fa-plus"></i>
                Create
            </button>
        </div>

    </div>
</template>

<script>

    import vSelect from "vue-select";
    import api from '../api';

    export default {

        props: {
            work_id: {
                type: Number,
                required: true,
            },
            reasons: {
                type: Array,
                required: false,
            },
        },

        data: () => ({
            message: null,
            reason_id: null,
            loading: false,
        }),

        components: { vSelect },

        methods: {
            submitIssue() {
                console.log(this.message, this.reason_id, this.work_id);
                this.loading = true;
                return api.createIssue(this.work_id, this.reason_id, this.message)
                    .then(data => {
                        this.closeModal();
                });
            },
            closeModal() {
                this.loading = false;
                this.$emit('close');
            },
        },

    }
</script>

<style>

    .issue-form {
        width: 100%;
    }

    .issue-form .row {
        padding: 10px 0;
    }

    .issue-form h1 .fas,
    .issue-buttons .btn .fas {
        margin-right: 10px;
    }

    .issue-buttons {
        text-align: center;
        margin: 15px 0;
    }

    .issue-buttons .btn {
        margin: 25px;
        color: #fff;
        font-weight: bold;
        padding: 8px 20px;
        font-size: 22px;
    }

    .btn-issue-create {
        background-color: #289b29;
    }

    .btn-issue-close {
        background-color: #7b7b7b;
    }

    .issue-form .btn[disabled],
    .issue-form fieldset[disabled] .btn {
        opacity: 0.5 !important;
    }

    .issue-form h2 {
        font-size: 17px;
        font-weight: bold;
        color: #666;
    }

    .issue-field-required::after {
        content: '*';
        color: #6d0000;
        font-weight: bold;
        top: 0;
        right: -10px;
        position: relative;
    }

    .issue-form input[type="text"] {
        width: 100%;
        border: 1px solid rgba(60,60,60,.26);
        border-radius: 4px;
        color: #333;
        line-height: 1.4;
        margin: 4px 2px 0;
        padding: 10px 16px;
    }

</style>
